import React from "react";
import strings from "./strings";

export default () => {
  return (
    <div className="footer text-center">
      <div className="grid">
        <div className="row" style={{ marginBottom: "0px" }}>
          {strings.contactUs}{" "}
          <a className="link" href="mailto:help@cloud.bme.hu">
            help@cloud.bme.hu
          </a>
        </div>
        <div className="row">
          © 2018 Copyright:
          <a className="link" href="http://ik.bme.hu">
            {" "}
            BME IK
          </a>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/Footer.js